import { Box, Typography } from "@mui/material";
import React from "react";

interface ColumnHeaderProps {
    text: string;
}

const ColumnHeader: React.FC<ColumnHeaderProps> = ({ text }) => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                padding: "0 16px",
                height: "100%",
            }}
        >
            <Typography
                sx={{
                    fontFamily: "Roboto",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "#49454F",
                }}
            >
                {text}
            </Typography>
        </Box>
    );
};

export default ColumnHeader;
